/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Header_SubtitleInputs */

const tr_mascot_chat_header_subtitle = /** @type {(inputs: Mascot_Chat_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel yardım asistanı`)
};

const en_mascot_chat_header_subtitle = /** @type {(inputs: Mascot_Chat_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel support assistant`)
};

const de_mascot_chat_header_subtitle = /** @type {(inputs: Mascot_Chat_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Support-Assistent`)
};

const ru_mascot_chat_header_subtitle = /** @type {(inputs: Mascot_Chat_Header_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассистент поддержки ShopPanel`)
};

/**
* | output |
* | --- |
* | "ShopPanel support assistant" |
*
* @param {Mascot_Chat_Header_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_header_subtitle = /** @type {((inputs?: Mascot_Chat_Header_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Header_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_header_subtitle(inputs)
	if (locale === "de") return de_mascot_chat_header_subtitle(inputs)
	if (locale === "ru") return ru_mascot_chat_header_subtitle(inputs)
	return tr_mascot_chat_header_subtitle(inputs)
});